import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { ConfigEnum } from "@/enums/httpEnum";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue"),
    meta: {
      title: "登录",
      requiresAuth: false,
    },
  },
  {
    path: "/home",
    name: "home",
    component: () => import(/* webpackChunkName: "home" */ "../views/Home.vue"),
    meta: {
      title: "首页",
    },
  },
  {
    path: "/homeTwo",
    name: "homeTwo",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/HomeTwo.vue"),
    meta: {
      title: "首页",
    },
  },
  {
    path: "/layout",
    name: "layout",
    component: () =>
      import(/* webpackChunkName: "layout" */ "../components/CustomLayout.vue"),
    children: [
      {
        path: "/account",
        name: "account",
        component: () =>
          import(/* webpackChunkName: "account" */ "../views/Account.vue"),
        meta: {
          title: "账户信息",
        },
      },
      {
        path: "/sortingWeighing",
        name: "sortingWeighing",
        component: () =>
          import(
            /* webpackChunkName: "sortingWeighing" */ "../views/SortingWeighing.vue"
          ),
        meta: {
          title: "分拣称重",
        },
      },
      {
        path: "/sortingWeighingFood",
        name: "sortingWeighingFood",
        component: () =>
          import(
            /* webpackChunkName: "sortingWeighing" */ "../views/SortingWeighingFood.vue"
          ),
        meta: {
          title: "食材分拣称重",
        },
      },
      {
        path: "/sortingWeighingSupplier",
        name: "sortingWeighingSupplier",
        component: () =>
          import(
            /* webpackChunkName: "SortingWeighingSupplier" */ "../views/SortingWeighingSupplier.vue"
          ),
        meta: {
          title: "分拣称重",
        },
      },
      {
        path: "/sortingWeighingCentralized",
        name: "sortingWeighingCentralized",
        component: () =>
          import(
            /* webpackChunkName: "SortingWeighingSupplier" */ "../views/sortingWeighingCentralized.vue"
          ),
        meta: {
          title: "集采收货",
        },
      },
      {
        path: "/smartOutbound",
        name: "smartOutbound",
        component: () =>
          import(
            /* webpackChunkName: "SmartOutbound" */ "../views/SmartOutbound.vue"
          ),
        meta: {
          title: "智慧出库",
        },
      },
      {
        path: "/outbound",
        name: "outbound",
        component: () =>
          import(/* webpackChunkName: "Outbound" */ "../views/Outbound.vue"),
        meta: {
          title: "分拣出库",
        },
      },
      {
        path: "/replenishment",
        name: "replenishment",
        component: () =>
          import(
            /* webpackChunkName: "replenishment" */ "../views/Replenishment.vue"
          ),
        meta: {
          title: "补货",
        },
      },
      {
        path: "/sortingWeighingFoodAI",
        name: "sortingWeighingFoodAI",
        component: () =>
          import(
            /* webpackChunkName: "sortingWeighing" */ "../views/SortingWeighingFoodAI.vue"
          ),
        meta: {
          title: "食材分拣称重AI识别",
        },
      },
      {
        path: "/speechDemo",
        name: "speechDemo",
        component: () =>
          import(
            /* webpackChunkName: "speechDemo" */ "../views/SpeechDemo.vue"
          ),
        meta: {
          title: "语音演示",
        },
      },
      {
        path: "/teachingPage",
        name: "teachingPage",
        component: () =>
          import(
            /* webpackChunkName: "speechDemo" */ "../views/teachingPage.vue"
          ),
        meta: {
          title: "教学视频",
        },
      },
      {
        path: "/statisticsScreen",
        name: "statisticsScreen",
        component: () =>
          import(
            /* webpackChunkName: "speechDemo" */ "../views/statisticsScreen.vue"
          ),
        meta: {
          title: "统计大屏",
        },
      },
    ],
  },
  {
    path: "/404",
    name: "notfount",
    component: () => import(/* webpackChunkName: "404" */ "../views/404.vue"),
  },
  {
    // path: "*", // 这样用，vue3已经不支持，得下面的方式
    path: "/:pathMath(.*)", // 此处需特别注意置于最底部
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  let token = localStorage.getItem(ConfigEnum.TOKEN);

  // 获取学校配置并判断版本
  const getTargetPage = (): string => {
    try {
      const schoolConfigStr = localStorage.getItem(ConfigEnum.SCHOOL_CONFIG);
      if (schoolConfigStr) {
        const schoolConfig = JSON.parse(schoolConfigStr);
        return schoolConfig?.pageTable === "v2" ? "/homeTwo" : "/home";
      }
    } catch (e) {
      console.error("解析school_config失败:", e);
    }
    return "/home";
  };

  if (to.name === "login" && token) {
    // 登录页面且已有token，根据版本跳转
    next(getTargetPage());
  } else if (to.name === "login" && !token) {
    next();
  } else if (!token) {
    next({ name: "login" });
  } else {
    next();
  }
});
export default router;
